module.exports = __webpack_public_path__ + "img/backgroundMenu.1e7b7d2c.png";